import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";

const ViewTollModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  const result = data?.find((item) => item.toll_id === id);
  // console.log("tollviewmodal", result);

  const [activeTab, setActiveTab] = useState("1");

  const style = `
    .custom-modal button {
      position: relative;
      top: 10px;
      right: 10px;
      // background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline: none !important;
    }
    .custom-modal button:hover,
    .custom-modal button:focus {
      color: #FF0000 !important;
      outline: none;
    }
    .custom-modal {
      overflow: auto;
    }
  `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white p-2 rounded-md"
        style={{ maxHeight: "600px", overflowY: "scroll" }}
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal">
          <p
            className="text-lg text-right mb-0 mt-4 pr-4 cursor-pointer"
            onClick={closeModal}
          >
            X
          </p>
          <h2 className="text-center font-bold text-lg ">Toll Details</h2>

          <div className="p-4 max-h-96">
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Toll Name
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.toll_name || "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      State
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.state_name || result?.state || "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      City
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.city_name || result?.city || "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Latitude
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.latitude || "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Longitude
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.longitude || "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Sedan (Tag / Cash)
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.sedan
                        ? `${result.sedan.tag_price ?? "-"} / ${
                            result.sedan.cash_price ?? "-"
                          }`
                        : "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      SUV (Tag / Cash)
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.suv
                        ? `${result.suv.tag_price ?? "-"} / ${
                            result.suv.cash_price ?? "-"
                          }`
                        : "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Tempo Traveller (Tag / Cash)
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.tempo_traveller
                        ? `${result.tempo_traveller.tag_price ?? "-"} / ${
                            result.tempo_traveller.cash_price ?? "-"
                          }`
                        : "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Status
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.status ? "Active" : "Inactive"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Remarks
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.remark || "-"}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewTollModal);
